import { publicCreateReturnRequest } from "@babackapp/private-api-client/client/use-public-create-return-request";
import type { SearchReturnRequestsResponseDto } from "@babackapp/private-api-client/generated/schema";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { buildReturnRequestPayload } from "../lib/return-request.lib";
import type { ReturnDraft } from "../types";

export function useCreateReturnRequest(orderId: string, shopSlug: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (draft: ReturnDraft) =>
      publicCreateReturnRequest(buildReturnRequestPayload(draft)),
    onSuccess: (newReturnRequest) => {
      // Eagerly add the new return request to all matching caches so the detail
      // page can navigate to it immediately without hitting a "not found" error
      // on the stale pre-invalidation data.
      queryClient.setQueriesData<SearchReturnRequestsResponseDto>(
        {
          predicate: (query) => {
            const key = query.queryKey;
            return key[0] === "get" && key[1] === "/public/return-request/search";
          },
        },
        (old) => {
          if (!old) return old;
          if (old.returnRequests.some((rr) => rr.id === newReturnRequest.id)) return old;
          return { returnRequests: [...old.returnRequests, newReturnRequest] };
        },
      );
      queryClient.invalidateQueries({
        queryKey: [
          "get",
          "/public/return-request/search",
          { params: { query: { orderId, shopSlug } } },
        ],
      });
    },
  });
}
